export default {
      id: "ic_aninda_para_yatir_video-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic_aninda_para_yatir_video-usage",
      toString: function () {
        return this.url;
      }
    }